var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"12","fill":"#E31D1C"}}),_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M8 2L8.89806 4.76393H11.8042L9.45308 6.47214L10.3511 9.23607L8 7.52786L5.64886 9.23607L6.54692 6.47214L4.19577 4.76393H7.10194L8 2Z","fill":"#FFD018"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }